<template>

    <form v-on:submit.prevent="run()" class="modal-card" style="min-width: 10em;">
        
        <section class="modal-card-body">
            <h1 class="title is-4">
                <i class="fa fa-magic"></i> AutoLabel</h1>
            <p class="subtitle">
                Speed up your annotation with label suggestions
            </p>
            <b-notification
            v-if="!hasEnoughCredits()"
            type="is-info"
            has-icon>
            Sorry, there's no credits available for an autolabel run.<br>.
            </b-notification>
            <b-button class="is-pulled-right" type="is-primary" tag="router-link" :to="'/d/pricing'">
                    <i class="fa fa-plus"></i> Add credits
                </b-button>
            <b-field label="AutoLabel cost" message="Preview of how much autolabel will cost">
                
                <p class="is-size-5">
                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"/></svg>
                    {{ creditsNeeded(5) }} credits ({{ availableCredits() }} credits available)<br>
                </p>
                
            </b-field>
            
            <b-field label="Filter dataset">
                <b-select
                    v-model="filter"
                    @input="filterRecords()"
                    placeholder="Filter records by"
                    expanded>
                    <option
                        v-for="option, idx in filter_options"
                        :key="idx"
                        :value="option">
                        Apply to {{ option }} records
                    </option>
                </b-select>
            </b-field>
            <b-field label="After run, validate the suggestions">
                <img :src="require('@/images/gifs/labeling.gif')" style="width: 50%;"/>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <b-button
                label="Close"
                @click="$emit('close')" />
            <b-button
                :disabled="!hasEnoughCredits()"
                tag="button"
                native-type="submit"
                label="Run AutoLabel"
                type="is-primary"
                expanded />
        </footer>
    </form>
    </template>
    <script>
    import { uuid } from 'vue-uuid'; 
    import mixin from '@/utils/sharedFunctions.js'

export default {
       mixins: [mixin],
       props: ["project", "rows"],
      data() {
        return {
          filter: 'unlabeled',
          filter_options: ['all', 'unlabeled'],
          filtered_rows: [],
          dataset: null,
          modelName: '',
          modelType: 'binary',
          trainingModels: 2,
          isFinished: false,
          selectedDataset: []
        };
      },
      mounted() {

        this.filterRecords()
        
      },
      computed: {
        datasets() {
            return [...this.$store.state.datasets, ...this.$store.state.publicDatasets]
        },
      },
      methods: {
            getRowsAdded(){
                return Math.max(10, this.filtered_rows.length)
            },
            filterRecords(){
                this.filtered_rows = this.rows.filter(row => {
                    if (this.filter == 'all'){
                        return true
                    }else if (this.filter == 'unlabeled'){
                        let type = this.project.type
                        if (type == 'classification') {
                            return (row.labels.length < 1)
                        } else {
                            return (row.tags.length < 1)
                        }
                    }
                })
            },
            openLoading() {
                    let isFullPage = true
                    const loadingComponent = this.$buefy.loading.open({
                        container: isFullPage ? null : this.$refs.element.$el
                    })

                    setTimeout(() => loadingComponent.close(), 1 * 1000)
                    
            },
            run() {

                this.openLoading()

                const payload = {
                    projectId: this.project.id,
                    filter: this.filter
                }

                this.$store.dispatch("runAutoLabel", 
                    payload
                );

                const toUpdateCreditsConsumed = {
                    userId: this.$firebase.auth().currentUser.uid,
                    creditConsumed: this.creditsNeeded(5)
                }

                this.$store.dispatch("updateAPICreditsConsumed", 
                    toUpdateCreditsConsumed
                );

                this.$buefy.notification.open(
                    'AutoLabel is running in the background. You will be notified when it is finished.'
                )

                this.$emit('close')

            }
        },
        
    }
    </script>